import Vue from 'vue';
import Vuex from 'vuex';

import Loading from './modules/loading';
import Session from './modules/session';
import Snackbar from './modules/snackbar';
import Error from './modules/error';
import Pagination from './modules/pagination';
import Post from './modules/post';
import Toolbar from './modules/toolbar';
import SchoolEvaluation from './modules/project_evaluation';
import Principal from './modules/principal';
import RegisterAid from './modules/register_aid';
import Dialog from './modules/dialog';
import SchoolClass from './modules/school_class';
import StudentOccurrence from './modules/student_occurrence';
import PresenceList from './modules/presence_list';
import BottomNav from './modules/bottom_nav';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Loading,
    Session,
    Snackbar,
    Error,
    Pagination,
    Post,
    Toolbar,
    SchoolEvaluation,
    Principal,
    RegisterAid,
    Dialog,
    SchoolClass,
    StudentOccurrence,
    PresenceList,
    BottomNav
  },
});
